import { createFileRoute } from '@tanstack/react-router'
import SettingsAPIKeysPage from '@/components/pages/Settings/team/SettingsAPIKeysPage/SettingsAPIKeysPage'

export const Route = createFileRoute('/$workspaceName/$environment/team-settings/api-keys')({
  component: ApiKeysSettingsRoute,
})

function ApiKeysSettingsRoute() {
  return <SettingsAPIKeysPage />
}
